import { SignUpBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { SignUpBlock } from './SignUpBlock';

export const SignUpBlockMapping: BlockMapping<SignUpBlockData> = {
  invariant: [],
  width: 'FULL',
  Component: SignUpBlock,
  AmpComponent: null,
};
